import styled from "styled-components";
import { variant } from "styled-system";
import { includeStyledSystem, sx } from "../../util/styledSystem";
const modalBodyVariants = {
    fullscreen: {
        flexGrow: 1,
        overflow: "auto",
    },
    normal: {},
};
export const ModalBody = styled.div `
  box-sizing: border-box;

  ${variant({ variants: modalBodyVariants })}

  ${includeStyledSystem()}
  ${sx}
`;
ModalBody.defaultProps = {
    variant: "normal",
};
